import Cookies from 'js-cookie'
import store from '@/store'

const TokenKey = 'accessToken'

export function getToken() {
  return Cookies.get(TokenKey)
  // return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
  // return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
  // localStorage.removeItem('loggedIn')
  // localStorage.removeItem('userInfo')
  // localStorage.removeItem(TokenKey)
}

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return getToken()
}

export const getUserData = () => store.getters.userData
